var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 15.5C12.825 15.5 13.5315 15.1962 14.1195 14.5886C14.7065 13.982 15 13.2525 15 12.4C15 11.5475 14.7065 10.8174 14.1195 10.2098C13.5315 9.60328 12.825 9.3 12 9.3C11.175 9.3 10.469 9.60328 9.882 10.2098C9.294 10.8174 9 11.5475 9 12.4C9 13.2525 9.294 13.982 9.882 14.5886C10.469 15.1962 11.175 15.5 12 15.5ZM12 31C7.975 27.4608 4.969 24.1733 2.982 21.1374C0.994 18.1024 0 15.2933 0 12.71C0 8.835 1.2065 5.74792 3.6195 3.44875C6.0315 1.14958 8.825 0 12 0C15.175 0 17.9685 1.14958 20.3805 3.44875C22.7935 5.74792 24 8.835 24 12.71C24 15.2933 23.0065 18.1024 21.0195 21.1374C19.0315 24.1733 16.025 27.4608 12 31Z",
    fill: "url(#paint0_linear_862_6573)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_862_6573",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#654D1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.ba192964fb4c314d6eda65e005f8544c.svg";
export { ForwardRef as ReactComponent };